import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { ProductCommentFormContext } from 'context';
import type {
  ComponentMode,
  ProductComment as ProductCommentConfig,
} from 'types';

import { ProductCommentForm, ProductCommentHeader } from './components';

type ProductCommentProps = {
  mode: ComponentMode;
};

export default function ProductComment({ mode }: ProductCommentProps) {
  const data = useLoaderData() as ProductCommentConfig | undefined;

  const { user, product, status } = data ?? {};
  const { userName, displayName, firstName, lastName, phoneNumber } =
    user ?? {};
  const { name: productName } = product ?? {};
  const isUpdatedMode = mode === 'Update';

  const defaultName = isUpdatedMode
    ? `دیدگاه "${
        userName ||
        displayName ||
        (firstName || lastName
          ? `${firstName || 'بدون نام'} ${lastName || ''}`
          : phoneNumber || 'ناشناس')
      }" برای "${productName || 'نامعلوم'}"`
    : '';
  const defaultStatus: typeof status = isUpdatedMode ? status : 'Accepted';
  const title = isUpdatedMode ? defaultName : 'افزودن دیدگاه جدید';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <ProductCommentHeader>{title}</ProductCommentHeader>
      <ProductCommentFormContext
        mode={mode}
        defaultName={defaultName}
        defaultStatus={defaultStatus}
        ownerType='Product'
        {...(isUpdatedMode ? data : {})}
      >
        <ProductCommentForm />
      </ProductCommentFormContext>
    </React.Fragment>
  );
}
